import React from 'react';
import Typography from '@material-ui/core/Typography';
import { useTranslation } from '../../../hooks/useTranslation';
import { Box, Grid } from '@material-ui/core';
import Dropdown from '../../dropdown';
import AlphaNumericTextField from '../../alpha-numeric-text-field';
import RegistrationFormProps from '../registration.types';
import {
  OnlineRegistrationType,
  PersonPrimaryIdType,
  StateIdType,
} from '../../../__generated__/pge-types';
import NewIdentityVerification from './NewIdentityVerification';

interface ExistingIdentityVerificationProps extends RegistrationFormProps {
  classes: any;
}

type SupportedIdTypes = PersonPrimaryIdType | StateIdType;

const ExistingIdentityVerification = (
  props: ExistingIdentityVerificationProps,
) => {
  const { t } = useTranslation();
  const { form } = props;

  const IDTypeMap: Partial<Record<SupportedIdTypes, string>> = {
    [StateIdType.DriverLicense]: t('DRIVERS_LICENSE'),
    [StateIdType.StateIdCard]: t('STATE_ID'),
    [PersonPrimaryIdType.Ssn]: t('SOCIAL_SECURITY_NUMBER'),
    [PersonPrimaryIdType.Dl]: t('DRIVERS_LICENSE'),
    [PersonPrimaryIdType.Ortrib]: t('OREGON_TRIBAL_ID'),
    [PersonPrimaryIdType.Visa]: t('VISA_ID_TEMP_STUDENT'),
    [PersonPrimaryIdType.Matr]: t('MATRICULA_ID'),
    [PersonPrimaryIdType.Military]: t('MILITARY_ID'),
    [PersonPrimaryIdType.Pssprt]: t('PASSPORT'),
    [PersonPrimaryIdType.Resalien]: t('RESIDENT_ALIEN_ID'),
    [PersonPrimaryIdType.Itin]: t('ITIN'),
    [PersonPrimaryIdType.Duns]: t('DUNS'),
    [PersonPrimaryIdType.Ein]: t('EIN'),
    [PersonPrimaryIdType.Wrksch]: t('WRKSCH'),
    [PersonPrimaryIdType.Essid]: t('ESSID'),
    [PersonPrimaryIdType.None]: t('ADD_NEW_ID'),
  };

  const availableIDTypes = form.values.availableExistingIDTypes || [];

  return (
    <div style={{ padding: 0 }}>
      <Grid
        container
        spacing={1}
        style={{
          justifyContent: 'flex-start',
        }}
      >
        <Grid item xs={12}>
          <Typography variant={'h2'} style={{ padding: '0 0 8px 0' }}>
            {t('PROVIDE_YOUR_EXISTING_ID_INFO')}
          </Typography>
          <Typography style={{ marginBottom: 4, marginTop: 4 }}>
            {form.values.registrationType === OnlineRegistrationType.Residential
              ? t('PROVIDE_YOUR_EXISTING_ID_DESCRIPTION')
              : t('PROVIDE_YOUR_EXISTING_ID_DESCRIPTION_BUSINESS')}
          </Typography>
        </Grid>
        <Grid item xs={12} style={{ display: 'flex', flexDirection: 'column' }}>
          <Box style={{ margin: '8px 0' }}>
            <Dropdown
              label={''}
              value={form.values.existingIDType}
              selectionList={availableIDTypes.map(idtype => ({
                value: idtype,
                label: IDTypeMap[idtype as SupportedIdTypes],
              }))}
              onChange={e => {
                void form.setValue('existingIDType', e.target.value);
              }}
            />
          </Box>
          {form.values.existingIDType !== PersonPrimaryIdType.None && (
            <AlphaNumericTextField
              inputProps={{ maxLength: 4, minLength: 1 }}
              label={t('LAST_4_DIGITS_OF_ID')}
              name="existingIDValue"
              data-testid="last-four-digit-id-value"
              {...form.props('existingIDValue')}
              delayedTextMask={true}
              error={Boolean(form.errors.existingIDValue)}
            />
          )}
        </Grid>
        <Grid item xs={12} css={{ marginTop: '16px' }}>
          {form.values.existingIDType === PersonPrimaryIdType.None && (
            <NewIdentityVerification {...props} />
          )}
        </Grid>
      </Grid>
    </div>
  );
};

export default ExistingIdentityVerification;
